import { Routes } from '@angular/router';
import { authGuard } from '@lite-workspace/shared/session';
import { AuthCallbackComponent } from '@lite-workspace/shared/session/callback';
import { ShellComponent } from './shell/shell.component';

export const appRoutes: Routes = [
  {
    // Must precede the guarded shell: the SSO redirect lands here with the session not yet proven,
    // so the guard would bounce the return straight back to login (redirect loop).
    path: 'auth/callback',
    // The cabinet has no impersonation and no magic-link entry, so every legitimate return here
    // echoes the state this tab minted — keep the strict check the app's own callback carried.
    data: { requireLoginState: true },
    component: AuthCallbackComponent,
  },
  {
    path: '',
    canMatch: [authGuard],
    component: ShellComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'galleries' },
      // The platform dashboard is the standalone dashboard app now; old in-app /home links land on the list.
      { path: 'home', redirectTo: 'galleries' },
      {
        path: 'galleries',
        loadComponent: () => import('./features/galleries/feature/galleries-page.component').then(m => m.GalleriesPageComponent),
      },
      {
        path: 'trash',
        loadComponent: () =>
          import('./features/galleries/feature/galleries-trash-page.component').then(m => m.GalleriesTrashPageComponent),
      },
      {
        path: 'account',
        loadComponent: () =>
          import('./features/account/feature/account-settings-host.component').then(m => m.AccountSettingsHostComponent),
      },
      {
        // Mail settings only: the cabinet has no feed, so «back» returns to the account settings that link here.
        path: 'notifications/settings',
        loadComponent: () => import('@lite-workspace/shared/blocks/notifications').then(m => m.NotificationSettingsPageComponent),
        data: { product: 'gallery', backLink: '/account', backLabel: 'К настройкам аккаунта' },
      },
      {
        path: 'email-templates',
        loadComponent: () =>
          import('./features/email-templates/feature/email-templates-page.component').then(m => m.EmailTemplatesPageComponent),
      },
      {
        path: 'presets',
        loadComponent: () =>
          import('./features/gallery-presets/feature/presets-page.component').then(m => m.PresetsPageComponent),
      },
      {
        path: 'presets/:presetId',
        loadComponent: () =>
          import('./features/gallery-presets/feature/preset-editor-page.component').then(m => m.PresetEditorPageComponent),
      },
      {
        path: 'galleries/:galleryId',
        loadComponent: () =>
          import('./features/gallery-manage/feature/gallery-manage-page.component').then(m => m.GalleryManagePageComponent),
      },
      {
        path: 'galleries/:galleryId/slideshow',
        loadComponent: () =>
          import('./features/slideshow/feature/gallery-slideshow-page.component').then(m => m.GallerySlideshowPageComponent),
      },
      {
        path: 'galleries/:galleryId/design',
        loadComponent: () =>
          import('./features/gallery-design/feature/gallery-design-page.component').then(m => m.GalleryDesignPageComponent),
      },
      {
        path: 'galleries/:galleryId/share',
        loadComponent: () =>
          import('./features/gallery-share/feature/gallery-share-page.component').then(m => m.GallerySharePageComponent),
      },
      {
        path: 'galleries/:galleryId/lists',
        loadComponent: () =>
          import('./features/gallery-lists/feature/gallery-lists-page.component').then(m => m.GalleryListsPageComponent),
      },
      {
        path: 'galleries/:galleryId/lists/:listId',
        loadComponent: () =>
          import('./features/gallery-lists/feature/gallery-list-page.component').then(m => m.GalleryListPageComponent),
      },
      {
        path: 'galleries/:galleryId/settings',
        loadComponent: () =>
          import('./features/gallery-settings/feature/gallery-settings-page.component').then(m => m.GallerySettingsPageComponent),
      },
      {
        path: 'galleries/:galleryId/stats',
        loadComponent: () =>
          import('./features/gallery-stats/feature/gallery-stats-page.component').then(m => m.GalleryStatsPageComponent),
      },
      {
        path: 'galleries/:galleryId/hidden-photos',
        loadComponent: () =>
          import('./features/gallery-hidden-photos/feature/gallery-hidden-photos-page.component').then(
            m => m.GalleryHiddenPhotosPageComponent,
          ),
      },
      // Inside the shell, not beside it: a top-level catch-all pointing back into the guarded tree
      // would re-enter the guard on every hop and loop while it redirects an anonymous visitor.
      { path: '**', redirectTo: 'galleries' },
    ],
  },
];
